import { FormOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, InputNumber, Modal, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import CurrencyInputCustom from '../../components/CurrencyInputCustom';
import MonedaSelector from '../../components/MonedaSelector';
import { currencyToNumber, errorHandler, tiposAutorizacion } from '../../utils';
import { instanceRef } from '../../utils/axios';

const DescuentoForm = ({ form, model, setModel, rowInicial }) => {
  useEffect(() => {
    setModel({
      ...model,
      ...form.getFieldsValue()
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Form
        initialValues={model}
        scrollToFirstError
        form={form}
        name="monto"
        autoComplete="off"
        layout="vertical"
      >
        <>
          <br />
          <Form.Item label="Desde" name="rango_porcentaje_desde">
            <InputNumber
              min={0}
              max={100}
              autoFocus
              bordered
              disabled={rowInicial}
            />
          </Form.Item>

          <Form.Item label="Hasta" name="rango_porcentaje_hasta">
            <InputNumber min={0} max={100} autoFocus bordered />
          </Form.Item>
        </>
      </Form>
    </>
  );
};

const MontoForm = ({ form, model, setModel, rowInicial }) => {
  const [monedas, setMonedas] = useState([]);
  const [monedaSelected, setMonedaSelected] = useState();

  const fetchMonedas = async () => {
    try {
      const monedasResponse = await instanceRef.instance.get(`/moneda`);
      setMonedaSelected(
        monedasResponse.data?.data.find(
          (item) => item.codigo.toString() === 'gs'
        )
      );
      setMonedas(monedasResponse.data?.data);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (monedaSelected) {
      setModel({
        ...model,
        ...form.getFieldsValue(),
        moneda: monedaSelected,
        id_moneda: monedaSelected.id
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monedaSelected]);

  useEffect(() => {
    fetchMonedas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Form
        initialValues={model}
        scrollToFirstError
        form={form}
        name="monto"
        autoComplete="off"
        layout="vertical"
      >
        {monedaSelected && (
          <>
            <MonedaSelector
              value={monedaSelected.codigo}
              monedas={monedas}
              onChange={(e) => {
                const selected = monedas.filter(
                  (mon) => mon.codigo === e.target.value
                )[0];
                setMonedaSelected(selected);
              }}
            />
            <br />
            <Form.Item
              label="Desde"
              name="rango_desde"
              normalize={(value) => currencyToNumber(value, monedaSelected)}
            >
              <CurrencyInputCustom
                moneda={monedaSelected}
                autoFocus
                bordered
                disabled={rowInicial}
              />
            </Form.Item>

            <Form.Item
              label="Hasta"
              name="rango_hasta"
              normalize={(value) => currencyToNumber(value, monedaSelected)}
            >
              <CurrencyInputCustom
                moneda={monedaSelected}
                autoFocus
                bordered
                placeholder="Monto máximo indeterminado"
              />
            </Form.Item>
          </>
        )}
      </Form>
    </>
  );
};

const AutorizacionTipoValidacionForm = ({
  tipo,
  width = 500,
  newAutorizacionConfig,
  setNewAutorizacionConfig,
  newAutorizacionConfigList,
  setNewAutorizacionConfigList,
  setCount,
  data,
  mostrarCopiarConfig,
  setLoading,
  idAseguradoraProducto,
  idAseguradoraEmpresaProducto,
  setCopiarConfig,
  ...props
}) => {
  const [form] = Form.useForm();
  const [rowInicial, setRowInicial] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [model, setModel] = useState({});

  const showModal = () => {
    if (
      !data &&
      newAutorizacionConfigList &&
      newAutorizacionConfigList.length > 0
    ) {
      const listOrdenado = newAutorizacionConfigList.sort(
        (n1, n2) => n1.rango_desde - n2.rango_desde
      );
      const lastAutConfig = listOrdenado[listOrdenado.length - 1];
      setModel(lastAutConfig);
      form.setFieldsValue(lastAutConfig);
    } else {
      setModel(data);
      form.setFieldsValue(data);
    }

    if (newAutorizacionConfigList.length === 1) {
      setRowInicial(true);
    } else {
      setRowInicial(false);
    }
    setIsModalOpen(true);
  };

  const handleOk = () => {
    if (tipo === 'monto' || tipo === 'montoitem' || tipo === 'descuento') {
      setNewAutorizacionConfig({
        ...model,
        ...form.getFieldsValue()
      });
    }

    form.resetFields();
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    clearAll();
    setIsModalOpen(false);
  };

  const clearAll = () => {};

  const getAutorizacionesConfig = async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get('/autorizacion/config', {
        params: {
          id: Number(idAseguradoraEmpresaProducto),
          tipo: 'aseguradoraEmpresaProducto'
        }
      });
      const autorizacionConfigListResponse = response.data?.data;
      if (autorizacionConfigListResponse) {
        if (autorizacionConfigListResponse.length > 0) {
          let row = 0;
          const autorizacionConfigListByTipoValidacion = autorizacionConfigListResponse.filter(
            (item) => {
              // TODO: Llevar filtro de tipoValidacion en el backend
              if (item.tipo_validacion.toUpperCase() === tipo.toUpperCase()) {
                const autorizacionConfig = item;
                row = Number(row + 1);
                autorizacionConfig.row = row;

                return autorizacionConfig;
              }
              return null;
            }
          );
          setCount(row);
          setNewAutorizacionConfigList(autorizacionConfigListByTipoValidacion);
        }
      }
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const upsertCopyAutorizacionConfig = async (list) => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.post(
        `autorizacion/config`,
        list,
        {
          params: {
            id: Number(idAseguradoraEmpresaProducto),
            tipo: 'aseguradoraEmpresaProducto'
          }
        }
      );
      if (response.data?.data) {
        return response.data?.data;
      }
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
    return null;
  };

  const copyAndInsertAutorizacionesConfig = async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get('/autorizacion/config', {
        params: { id: idAseguradoraProducto, tipo: 'aseguradoraProducto' }
      });
      const autorizacionConfigCopyList = response.data?.data;
      if (autorizacionConfigCopyList) {
        if (autorizacionConfigCopyList.length > 0) {
          let row = 0;
          const autorizacionConfigList = autorizacionConfigCopyList.filter(
            (item) => {
              if (item.tipo_validacion.toUpperCase() === tipo.toUpperCase()) {
                const autorizacionConfig = item;
                const newAutConfigDetalleList = item.autorizacionConfigDetalles.map(
                  (detalle) => {
                    const autDetalle = detalle;
                    autDetalle.id = null;
                    autDetalle.id_autorizacion_config = null;
                    return autDetalle;
                  }
                );

                row = Number(row + 1);
                autorizacionConfig.row = row;
                autorizacionConfig.id = null;
                autorizacionConfig.id_aseguradora_producto = null;
                autorizacionConfig.id_aseguradora_empresa_producto = idAseguradoraEmpresaProducto;
                autorizacionConfig.token = null;
                autorizacionConfig.autorizacionConfigDetalles = newAutConfigDetalleList;
                autorizacionConfig.cP = item.cP.filter(
                  (control) => !control.eliminado
                );
                return autorizacionConfig;
              }
              return null;
            }
          );

          for (let i = 0; i < autorizacionConfigList.length; i += 1) {
            const autorizacionConfigToInsert = autorizacionConfigList[i];
            // eslint-disable-next-line no-await-in-loop
            await upsertCopyAutorizacionConfig([autorizacionConfigToInsert]);
          }
        }
      }

      getAutorizacionesConfig();
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const copyConfigEstandar = () => {
    if (idAseguradoraProducto) {
      copyAndInsertAutorizacionesConfig();
    } else {
      errorHandler('No se logra obtener la copia');
    }
  };

  return (
    <>
      {!mostrarCopiarConfig &&
        (tipo === 'monto' || tipo === 'montoitem' || tipo === 'descuento') &&
        (!data ? (
          // Agregar model
          <Space size="small">
            <Button
              key="2"
              type="dashed"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={showModal}
            >
              Agregar nuevo{' '}
              {/* tiposAutorizacion.find((item) => item.key === tipo).tipo */}
            </Button>
          </Space>
        ) : (
          // Editar modelo
          <Button
            type="text"
            icon={<FormOutlined />}
            size="middle"
            onClick={showModal}
            disabled={props.disabled}
          />
        ))}

      {mostrarCopiarConfig && (
        <>
          <Space size="small">
            <Button
              key="2"
              type="dashed"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={() =>
                tipo === 'monto' || tipo === 'montoitem' || tipo === 'descuento'
                  ? showModal()
                  : setCount(1)
              }
            >
              Agregar nueva validación{' '}
              {/* tiposAutorizacion.find((item) => item.key === tipo).tipo */}
            </Button>
            <Button
              key="estandar"
              type="dashed"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={copyConfigEstandar}
            >
              Copiar Configuración existente del producto{' '}
              {/* tiposAutorizacion.find((item) => item.key === tipo).tipo */}
            </Button>
          </Space>
        </>
      )}

      <Modal
        title={tiposAutorizacion.find((item) => item.key === tipo).tipo}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={width}
      >
        <>
          {tipo === 'monto' || tipo === 'montoitem' ? (
            <MontoForm form={form} {...{ model, setModel, rowInicial }} />
          ) : (
            <DescuentoForm form={form} {...{ model, setModel, rowInicial }} />
          )}
        </>
      </Modal>
    </>
  );
};

export default AutorizacionTipoValidacionForm;
